<template>

    <div>
        <div class="row">
            <p class="text-center w-100">
                <span class="mt-3 text-azul-escuro">
                    Essas são as formas possíveis para você se <strong>autenticar</strong>.

                </span>
            </p>
            <div class="px-0 col-md-6 pb-3" v-for="item in items" v-bind:key="item.metodoAcessoId">
                <div v-if="item.unico">
                    <strong>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 1">CPF/CNPJ:</span>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 2">E-mail:</span>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 3">Celular:</span>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 4">Username:</span>
                    </strong>
                    <br />
                    <span class="text-primary">{{ item.loginExibicao }}</span>
                </div>
                <div v-else>
                    <strong class="text-danger">
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 1">CPF/CNPJ:</span>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 2">E-mail:</span>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 3">Celular:</span>
                        <span class="text-azul-escuro" v-if="item.metodoAcessoId == 4">UserName:</span>
                        <br />
                        <span>{{ item.loginExibicao }}</span>
                        <br />
                        <small>Já existe um acesso configurado para este login.</small>
                    </strong>
                </div>
            </div>
        </div>

        <!--<div class="row">
        <span class="text-center mt-3 text-azul-escuro">
            <p>Selecione a melhor forma para você se <strong>autenticar</strong> e continuar o processo</p>
        </span>
        <div class="col-md-6 pb-3" v-for="item in items" v-bind:key="item.metodoAcessoId">
            <div class="custom-control custom-radio custom-control-inline" v-if="item.unico">
                <input type="radio" :id="'acesso-' + item.metodoAcessoId" :value="item" v-model="metodoAcesso" name="acesso" class="custom-control-input">
                <label class="custom-control-label" :for="'acesso-' + item.metodoAcessoId">
                    <span class="text-azul-escuro" v-if="item.metodoAcessoId == 1">CPF/CNPJ:</span>
                    <span class="text-azul-escuro" v-if="item.metodoAcessoId == 2">E-mail:</span>
                    <span class="text-azul-escuro" v-if="item.metodoAcessoId == 3">Celular:</span>
                    <br />
                    <span class="text-primary">{{ item.loginExibicao }}</span>
                </label>
            </div>
            <div v-else>
                <span class="text-azul-escuro" v-if="item.metodoAcessoId == 1">CPF/CNPJ:</span>
                <span class="text-azul-escuro" v-if="item.metodoAcessoId == 2">E-mail:</span>
                <span class="text-azul-escuro" v-if="item.metodoAcessoId == 3">Celular:</span>
                <br />
                <span class="text-danger">{{ item.loginExibicao }}</span>
            </div>
        </div>
    </div>-->

        <div class="row mt-2">
            <div class="col-6">
                <button type="button" class="btn btn-light border-primary rounded-pill previous-button px-4" @click="sendBack()">Voltar</button>
            </div>
            <div class="col-6 text-right">
                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="confirmarMetodoAcesso()">Continuar</button>
            </div>
        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCodigoAcesso" :hide-footer="true" title="Confirmação">
            <div v-if="metodoAcesso">
                <h4 class="text-center text-azul-escuro">Está faltando pouco para ativar sua conta!</h4>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <span class="text-center mt-3 text-azul-escuro">
                            Para prosseguir, enviamos um código para <strong>{{ metodoAcesso.login }}</strong>.
                            Insira a informação abaixo.
                        </span>
                    </div>
                    <div class="form-group col-md-12">
                        <input type="text" class="form-control" name="codigoValidacao" autocomplete="off" v-model="metodoAcesso.codigoValidacao" />
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-6">
                        <button type="button" class="btn btn-info btn-block rounded-pill" @click="confirmarMetodoAcesso(true)">Reenviar</button>
                    </div>
                    <div class="col-md-6">
                        <button type="button" class="btn btn-secondary btn-block rounded-pill" @click="confirmarCodigoAcesso()">Confirmar</button>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>

</template>



<script>
    import { Api } from '@/common/api'
    import base from '@/common/base.js'

    export default {
        name: 'cadastro-acesso',
        mixins: [base],
        props: {
            model: Object
        },
        data: () => ({
            items: [],
            metodoAcesso: null,
            dialogCodigoAcesso: false
        }),
        methods: {
            buscarFormasAcesso() {
                this.showLoading()
                new Api('pessoacnaacesso/buscarformasacesso')
                    .get({ pessoaCNAId: this.model.pessoaCNAId })
                    .then(result => {
                        this.items = result.dataList;
                        this.metodoAcesso = this.items[0];
                        this.hideLoading()
                    }, err => {
                        this.defaultErrorResult(err, true);
                    })
            },
            confirmarMetodoAcesso(_reenvio) {
                this.showLoading()
                new Api('pessoacnaacesso')
                    .post(this.metodoAcesso)
                    .then(result => {
                        this.hideLoading()
                        let _data = result.data;

                        this.metodoAcesso.pessoaCNAAcessoId = _data.pessoaCNAAcessoId;

                        if (_data.validado == false) {
                            if (_reenvio) this.defaultSuccessResult("Código enviado!");
                            this.dialogCodigoAcesso = true;
                        }
                        else {
                            this.defaultSuccessResult("Acesso configurado, agora só falta você inserir sua senha de acesso!");
                            this.$emit('on-next', true);
                        }
                    }, err => {
                        this.defaultErrorResult(err, true);
                    })
            },
            confirmarCodigoAcesso() {
                this.showLoading()
                new Api('pessoacnaacesso/validacodigoacesso')
                    .post(this.metodoAcesso)
                    .then(result => {
                        this.hideLoading()
                        this.dialogCodigoAcesso = false
                        if (result.data) {
                            this.defaultSuccessResult("Acesso configurado, agora só falta você inserir sua senha de acesso!");
                            this.$emit('on-next', result.data);
                        }
                    }, err => {
                        this.defaultErrorResult(err, true);
                    })
            },
            sendBack() {
                this.$emit('on-back')
            }
        },

        mounted() {
            if (this.model)
                this.buscarFormasAcesso();
        }
    };
</script>
